import React, { PureComponent, Fragment } from 'react';
import { DEFAULT_PERKS } from 'utils/constants';
import {
  Button,
  Grid,
  Typography,
  Box,
  TextField,
  Chip,
} from '@material-ui/core';
import './onboarding.scss';

class OnboardingStep3 extends PureComponent {
  constructor() {
    super();
    this.state = {
      inputPerk: '',
    };
  }

  updatePerks = (perk, allPerks) => {
    const { perks, onChange } = this.props;
    const e = {
      target: {
        name: 'perks',
        value: `${perks.length ? perks.join(',') + ',' : ''}${perk}`,
      },
    };

    if (allPerks) {
      e.target.value = allPerks.join(',');
    }

    onChange(e);
    this.setState({
      inputPerk: '',
    });
  };

  onChangeHandler = (e) => {
    if (e.key === 'Enter') {
      const { inputPerk } = this.state;
      this.updatePerks(inputPerk);

      return;
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onClickPerk = (perk) => () => {
    this.updatePerks(perk);
  };

  onDeletePerk = (perk) => () => {
    const { perks } = this.props;

    if (!perks.length) {
      return;
    }

    const filteredPerks = perks.filter((p) => p !== perk);
    this.updatePerks('', filteredPerks);
  };

  render() {
    const { perks, onClickSave, onCLickNext } = this.props;
    const { inputPerk } = this.state;

    return (
      <Fragment>
        <Typography variant="h4" className="heading">
          Perks and benefits
        </Typography>
        <Box marginTop="20px" marginBottom="10px">
          <Grid container spacing={0}>
            {[...new Set([...DEFAULT_PERKS, ...perks])].map((perk) => (
              <Chip
                variant="outlined"
                onDelete={this.onDeletePerk(perk)}
                onClick={this.onClickPerk(perk)}
                label={perk}
                color={perks.includes(perk) ? 'primary' : 'default'}
                clickable
                style={{
                  borderRadius: '4px',
                  marginRight: '8px',
                  marginBottom: '8px',
                }}
              />
            ))}
          </Grid>
        </Box>
        <TextField
          id="outlined-name"
          label="Add your Perks"
          margin="normal"
          variant="outlined"
          placeholder="Enter your perks here"
          name="inputPerk"
          value={inputPerk}
          onChange={this.onChangeHandler}
          onKeyPress={this.onChangeHandler}
          fullWidth
        />
        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={5}>
            <Box marginTop="20px">
              <Button
                variant="outlined"
                color="default"
                fullWidth
                size="large"
                onClick={onCLickNext(2)}
              >
                Back
              </Button>
            </Box>
          </Grid>
          <Grid item xs={5}>
            <Box marginTop="20px">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                onClick={onClickSave}
              >
                Let me explore
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

export default OnboardingStep3;
